import * as React from "react";
import Typography from "@mui/material/Typography";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import MuiSelect from "@mui/material/Select";
import { Box, FormHelperText } from "@mui/material";
import { KeyboardArrowDown } from "@mui/icons-material";

export default function SelectField2({
    options,
    defaultValue = "sort",
    error,
    height = "30px",
    placeholder,
    withoutBorder = false,
    label,
    ...props
}) {
    return (
        <FormControl sx={{ width: "100%", position: "relative" }}>
            <Box
                sx={{
                    fontWeight: "500",
                    pb: "0.5rem",

                    fontSize: "16px",
                    color: "#011D38",
                    textShadow: "0.5px 0.5px rgba(0, 0, 0, 0.1)",
                    letterSpacing: "0.5px",
                    // lineHeight: "1.4",
                }}
            >
                {label}
            </Box>

            <MuiSelect
                defaultValue={defaultValue}
                sx={{
                    //   backgroundColor: error ? "#d9255016" : "#f5f5f8",
                    border: error ? "1px solid #FF4D4F" : "1px solid #ACB2B9",
                    borderRadius: "10px",
                    backgroundColor: error ? "#d9255016" : "#FFFFFF",
                    outline: "none",
                    display: "flex",
                    alignItems: "center",
                    height: "40px !important",

                    color: "#8f8fa7",
                    ".MuiOutlinedInput-notchedOutline": {
                        padding: "10px !important",
                        border: "none",
                        outline: "none !important",
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        border: "1px solid rgba(166, 166, 167, 0.87) !important",
                        outline: "1px solid #d4d6f5",
                    },
                    "&:hover .MuiOutlinedInput-notchedOutline": {
                        borderColor: "transparent",
                        outline: "none",
                    },
                    ".MuiSvgIcon-root ": {
                        color: "#8f8fa7",
                        position: "absolute",
                        right: "6px",
                        pointerEvents: "none",
                    },
                    ".MuiInputBase-input": {
                        padding: "10px 15px",
                    },
                }}
                IconComponent={() => (
                    <KeyboardArrowDown sx={{ color: "#8f8fa7 !important" }} />
                )}
                MenuProps={{
                    PaperProps: {
                        sx: {
                            border: "1px solid #E9E9E9", // Add border to the dropdown
                            borderRadius: "10px", // Optional: Add border radius
                            boxShadow:
                                "0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)", // Optional: Add shadow
                        },
                    },
                }}
                {...props}
            >
                {placeholder && (
                    <MenuItem value="sort" disabled>
                        <Box sx={{ color: "#8f8fa7", fontSize: "14px", fontWeight: "500" }}>
                            {placeholder}
                        </Box>
                    </MenuItem>
                )}
                {options?.map((option, index) => (
                    <MenuItem
                        key={index}
                        value={option.value}
                        sx={{
                            "&:hover": {
                                backgroundColor: "rgba(70, 130, 180, 1)",
                                color: "white",
                            },
                        }}
                    >
                        <Typography
                            sx={{ color: "#565050", fontSize: "16px", fontWeight: "500" }}
                        >
                            {option.label}
                        </Typography>
                    </MenuItem>
                ))}
            </MuiSelect>
            {error && (
                <FormHelperText
                    sx={{ color: "#FF4D4F", fontWeight: "600", fontSize: "13px" }}
                >
                    {error}
                </FormHelperText>
            )}
        </FormControl>
    );
}
